module.exports = __webpack_public_path__ + "static/banner-067960a19b063bd7e891250972e1e440.jpg";